export const start = async function(tabsContainerId) {
    var tabs = document.getElementById(tabsContainerId)
    tabs = tabs.getElementsByClassName('tab');
    Array.from(tabs).forEach((tab, i) => {
        tab.addEventListener("click", (e) => changeTab(tabsContainerId, i))
    });
}



//chared functions

function changeTab(tabsContainerId, activedIndex) {
    console.log('tabsContainerId, activedIndex', tabsContainerId, activedIndex)
    var tabs = document.getElementById(tabsContainerId)
    tabs = Array.from(tabs.getElementsByClassName('tab'));

    var tabsContents = document.getElementById(`${tabsContainerId}Content`)
    tabsContents = Array.from(tabsContents.getElementsByClassName('tabContent'));


    tabs.forEach((tab, i) => {
        if (i == activedIndex) {
            tab.classList.add('active');
            tabsContents[i].classList.add('active');
        } else {
            tab.classList.remove('active');
            tabsContents[i].classList.remove('active');
        }

    });

    // .hide {
    //     display: none;
    // }
}
